import React, {Suspense} from 'react';
import {Outlet, useOutletContext} from 'react-router-dom';
import OfflineBanner from '../components/OfflineBanner';
import PwaUpdateNotice from '../components/PwaUpdateNotice';
import SyncStatus from '../components/SyncStatus';
import {CaptureSafetyProvider} from '../contexts/CaptureSafetyContext';
import {useBusiness} from '../contexts/BusinessContext';
import Sidebar from '../components/Sidebar';
import MobileNavigation from '../components/MobileNavigation';
import RouteLoadingFallback from '../components/RouteLoadingFallback';
import {useLanguage} from '../contexts/LanguageContext';
import CardFreeTrialNotice from '../components/CardFreeTrialNotice';

function DashboardLayout() {
  const session = useOutletContext();
  const {activeBusiness, isLoading: isWorkspaceLoading} = useBusiness();
  const {t} = useLanguage();

  return (
    <div className="min-h-screen overflow-x-clip bg-surface">
      <a href="#workspace-main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-xl focus:bg-white focus:p-4">{t('Skip to content')}</a>
      <Sidebar session={session} />
      <MobileNavigation session={session} />
      <main id="workspace-main" className="min-h-screen min-w-0 overflow-x-clip pb-[calc(6rem+var(--app-safe-area-bottom))] lg:ml-[248px] lg:pb-8">
        <div className="hidden min-h-16 items-center justify-between gap-4 border-b border-slate-200/70 bg-white px-8 lg:flex">
          <div>
            <p className="text-xs font-medium text-slate-500">{t('Workspace')}</p>
            {isWorkspaceLoading ? (
              <div className="mt-2 h-4 w-36 animate-pulse rounded-full bg-slate-200 motion-reduce:animate-none" aria-hidden="true" />
            ) : (
              <p className="mt-1 text-sm font-semibold text-ink">{activeBusiness?.name || t('Your Business')}</p>
            )}
          </div>
          <SyncStatus />
        </div>
        <CaptureSafetyProvider>
          <OfflineBanner />
          <PwaUpdateNotice />
          <CardFreeTrialNotice />
          {isWorkspaceLoading ? (
            <RouteLoadingFallback workspace />
          ) : (
            <Suspense fallback={<RouteLoadingFallback workspace />}>
              <Outlet context={session} />
            </Suspense>
          )}
        </CaptureSafetyProvider>
      </main>
    </div>
  );
}

export default DashboardLayout;
